/**
 * Product screenshots used on the public pages.
 *
 * WebP at 1600 px wide, each under 200 KB (framing V13). Explicit
 * dimensions let the browser reserve space before the image arrives, so
 * the landing page's layout does not shift (CLS). Source PNGs are kept in
 * `.i/img/screenshot/`.
 */

import harbourOriginal from '../assets/screenshot/harbour-blvd-original.webp';
import harbourSbPriority from '../assets/screenshot/harbour-blvd-sb-priority.webp';
import riversidePmPeak from '../assets/screenshot/riverside-dr-pm-peak.webp';
import pacificOriginal from '../assets/screenshot/pacific-hwy-original.webp';

export interface Screenshot {
  src: string;
  width: number;
  height: number;
  alt: string;
  caption: string;
}

export const SCREENSHOT = {
  riversidePmPeak: {
    src: riversidePmPeak,
    width: 1600,
    height: 828,
    alt: 'SigTDD time-distance diagram of the six-intersection Riverside Drive corridor with the northbound green wave band highlighted',
    caption: 'Riverside Drive, PM Peak plan — six intersections, northbound progression band',
  },
  harbourOriginal: {
    src: harbourOriginal,
    width: 1600,
    height: 821,
    alt: 'SigTDD time-distance diagram of a seven-intersection corridor with phase bars, offsets and progression bands',
    caption: 'Harbour Boulevard, Original plan — seven intersections, both directions shown',
  },
  harbourSbPriority: {
    src: harbourSbPriority,
    width: 1600,
    height: 820,
    alt: 'The same corridor with a southbound-priority timing plan selected in the plan selector',
    caption: 'Harbour Boulevard, SB Priority plan — one corridor, several timing plans',
  },
  pacificOriginal: {
    src: pacificOriginal,
    width: 1600,
    height: 811,
    alt: 'SigTDD time-distance diagram of a ten-intersection highway corridor with bandwidth shown in the header',
    caption: 'Pacific Highway — ten intersections, 5.65 km, bandwidth read directly from the corridor header',
  },
} as const satisfies Record<string, Screenshot>;

export const SCREENSHOT_LIST: readonly Screenshot[] = [
  SCREENSHOT.riversidePmPeak,
  SCREENSHOT.harbourOriginal,
  SCREENSHOT.harbourSbPriority,
  SCREENSHOT.pacificOriginal,
];
